import Route from '@ember/routing/route';
import { inject as service } from '@ember/service';

class AdminSiteConfigRoute extends Route {
  @service store;

  /** @inheritDoc */
  model() {
    // there should only ever be one site-config model so we grab the first (and only) object from the collection
    return this.store.findAll('site-config').then((res) => res.firstObject);
  }
}

export default AdminSiteConfigRoute;
